import type { GetSrcArgs } from 'openimg/react'

type TargetFormat = 'avif' | 'webp'

// Your Cloudflare R2 bucket URL
const R2_BUCKET_URL = ENV.R2_PUBLIC_URL || 'https://your-r2-bucket.r2.dev'

export const getSrc = ({ src, width, height, fit, format, optimizerEndpoint }: GetSrcArgs) => {
  // Handle local images
  if (src.startsWith('/img/')) {
    const params = new URLSearchParams({
      src,
      w: width.toString(),
      h: height.toString(),
    })
    if (fit) params.append('fit', fit)
    if (format) params.append('format', format)
    return `${optimizerEndpoint}?${params.toString()}`
  }

  // Handle Imgur images
  if (src.includes('imgur.com')) {
    const imgurId = src.split('/').pop()?.split('.')[0]
    if (!imgurId) return src

    const params = new URLSearchParams({
      src: `https://i.imgur.com/${imgurId}.jpg`,
      w: width.toString(),
      h: height.toString(),
    })
    if (fit) params.append('fit', fit)
    if (format) params.append('format', format)
    return `${optimizerEndpoint}?${params.toString()}`
  }

  // Handle Google Drive images
  if (src.includes('drive.google.com')) {
    // Extract file ID from Google Drive URL
    const fileId = src.match(/\/d\/([^\/]+)/)?.[1] || src.match(/id=([^&]+)/)?.[1]
    if (!fileId) return src

    const params = new URLSearchParams({
      src: `https://drive.google.com/uc?export=view&id=${fileId}`,
      w: width.toString(),
      h: height.toString(),
    })
    if (fit) params.append('fit', fit)
    if (format) params.append('format', format)
    return `${optimizerEndpoint}?${params.toString()}`
  }

  // Handle ImageKit images
  if (src.includes('ik.imagekit.io')) {
    const params = new URLSearchParams({
      src,
      w: width.toString(),
      h: height.toString(),
    })
    if (fit) params.append('fit', fit)
    if (format) params.append('format', format)
    return `${optimizerEndpoint}?${params.toString()}`
  }

  // Handle R2 images
  if (src.startsWith(R2_BUCKET_URL)) {
    const params = new URLSearchParams({
      src,
      w: width.toString(),
      h: height.toString(),
    })
    if (fit) params.append('fit', fit)
    if (format) params.append('format', format)
    return `${optimizerEndpoint}?${params.toString()}`
  }

  // Fallback for other URLs
  return src
}

// Default breakpoints based on Tailwind's breakpoints
export const defaultBreakpoints = [640, 768, 1024, 1280, 1536]

// Default formats to support
export const defaultFormats: TargetFormat[] = ['avif', 'webp'] 